import { Component, Input } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-analysis-requested',
  templateUrl: './activity-item-project-analysis-requested.component.html',
  styleUrls: ['./activity-item-project-analysis-requested.component.scss']
})
export class ActivityItemProjectAnalysisRequestedComponent {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  // what the customer asked to be considered, written in the request modal
  get comment() {
    return this.activity?.Payload?.Comment;
  }

}
